export default {
    
    indexDynamicDivisions:           { method: 'get',    url: 'dynamic_divisions' },
    createDynamicDivision:           { method: 'post',   url: 'dynamic_divisions'},
    updateDynamicDivision:           { method: 'put',    url: 'dynamic_divisions/{id}'},
    deleteDynamicDivision:           { method: 'delete', url: 'dynamic_divisions/{id}'},
    generateDynamicDivision:         { method: 'put',    url: 'dynamic_divisions/{id}/generate' },
    syncDynamicDivision:             { method: 'put',    url: 'dynamic_divisions/{id}/sync' },
    showDynamicDivisionViewResults:  { method: 'get',    url: 'dynamic_divisions/{id}/view-results' },
    indexDynamicDivisionStatus:      { method: 'get',    url: 'dynamic_divisions/status' },
    indexDynamicDivisionTypes:       { method: 'get',    url: 'dynamic_divisions/types' },
    
}